import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '../../../pages/_banner/ConnectButton';
import Wrapper from '../../../pages/_banner/Wrapper';
import useDialogLauncher from '../../_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';

CreatorBanner.propTypes = {
  event: PropTypes.object.isRequired
};

export default function CreatorBanner(props) {
  const { event, creator } = props;

  const launch = useDialogLauncher();

  function onManage() {
    launch(DialogManager.EventManage.Config(event.id, '/manage'));
  }

  return (
    <Wrapper
      creator={creator}
      title={(
        <>
          This is your event.
        </>
      )}
      subtitle={(
        <>
          Click the button below to edit the details, invite partners, or message
          existing collaborators.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton onClick={onManage}>
          Manage event
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
